module.exports = __webpack_public_path__ + "static/media/tiktok-dark.191d60a2.svg";